/**
 * Favorites types
 *
 * @type {{}}
 */
export const types = {
  product: 'product',
  service: 'service',
  advert: 'advert',
  company: 'company'
};
export const typesTitle = {
  [types.product]: 'Продукт',
  [types.service]: 'Услуга',
  [types.advert]: 'Объявление',
  [types.company]: 'Компания'
};